module.exports = __webpack_public_path__ + "img/logo-icon.d3c07754.png";